import { render, staticRenderFns } from "./CambiarSedeModal.vue?vue&type=template&id=5c49f522&"
import script from "./CambiarSedeModal.vue?vue&type=script&lang=js&"
export * from "./CambiarSedeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports